import { readImportedInvoiceAnalysis, type ImportedDoc, type FactureDraft } from "compta-shared";

export const shouldStartImportedInvoiceAnalysis = (
  doc: Pick<ImportedDoc, "analysis" | "analysisStatus"> & { reviewDraft?: FactureDraft | null },
) => !doc.reviewDraft && !doc.analysis && doc.analysisStatus !== "analyzing";

export const getImportedInvoiceReviewInitialValues = (value: unknown, review?: FactureDraft | null) => {
  const analysis = readImportedInvoiceAnalysis(value);
  return {
    analysis,
    emetteur: review ? review.libellé : analysis?.supplierName ?? "",
    invoiceType: review ? review.invoiceType : analysis?.invoiceType ?? "normal",
    modeRef: review ? review.modeRef : analysis?.invoiceReference ?? "",
    montantCent: review ? review.montantCent : analysis?.amountCent ?? null,
    dateFacture: review ? review.dateFacture : analysis?.invoiceDate ?? null,
    datePrelevement: review ? review.datePrelevement : analysis?.debitDate ?? null,
    paymentDueDate: review ? review.paymentDueDate : analysis?.paymentDueDate ?? null,
    montantTitresCent: review ? review.montantTitresCent : analysis?.voucherAmountCent ?? null,
    montantFraisCent: review ? review.montantFraisCent : analysis?.feesAmountCent ?? null,
  };
};

export const shouldConfirmImportedInvoiceAnalysis = (
  values: Omit<
    ReturnType<typeof getImportedInvoiceReviewInitialValues>,
    "emetteur" | "invoiceType"
  >,
) =>
  values.analysis !== null ||
  values.modeRef.trim() !== "" ||
  values.montantCent !== null ||
  values.dateFacture !== null ||
  values.datePrelevement !== null ||
  values.paymentDueDate !== null ||
  values.montantTitresCent !== null ||
  values.montantFraisCent !== null;
